import {
  PrimaryButton,
  Container,
  OutlinedButton,
} from "@bloomberg/media-ui-core";
import React, { useCallback } from "react";
import { trackClickEvent } from "@foundation/nextjs-gtm";
import styles from "./signedOutWatchlistContainer.module.css";

type SignedOutWatchlistContainerProps = {
  signInModal: () => void;
  registerModal: () => void;
};

export default function SignedOutWatchlistContainer(
  props: SignedOutWatchlistContainerProps
) {
  const { signInModal, registerModal } = props;

  const handleSignInClick = useCallback(() => {
    trackClickEvent("watchlistLogIn", "login", "click", "watchlist");
    signInModal();
  }, [signInModal]);

  const handleRegisterClick = useCallback(() => {
    trackClickEvent("watchlistLogIn", "login", "click", "watchlist");
    registerModal();
  }, [registerModal]);

  return (
    <Container rounded className={styles.createWatchlistContainer}>
      <div className={styles.createWatchlistContent}>
        <div className={styles.bannerText}>
          Effortlessly monitor stocks, indexes, and relevant news in one place.
        </div>

        <div className={styles.buttons}>
          <PrimaryButton
            onClick={handleSignInClick}
            rounded
            className={styles.signInButton}
          >
            <span>Sign In</span>
          </PrimaryButton>
          <PrimaryButton
            onClick={handleSignInClick}
            rounded
            size="small"
            className={styles.signInButtonMobile}
          >
            <span>Sign In</span>
          </PrimaryButton>
          <OutlinedButton
            title="Create Account"
            onClick={handleRegisterClick}
            className={styles.createAccountButton}
          >
            <span>Create Account</span>
          </OutlinedButton>
          <OutlinedButton
            title="Create Account"
            size="small"
            onClick={registerModal}
            className={styles.createAccountButtonMobile}
          >
            <span>Create Account</span>
          </OutlinedButton>
        </div>
      </div>
    </Container>
  );
}
